import http from '@/utils/httpService';
import { rootPath } from '@/utils/globalParam';

// v1.7预约服务服务管理、顾问心选
export default {
  // 查看当天是否预约
  HasAppoint: data => http.Axios.post(rootPath + '/api/appointRecord/hasAppoint', data),

  // 立即预约
  Appoint: data => http.Axios.post(rootPath + '/api/appointRecord/appoint', data),

  // 猜你喜欢
  RandomWelfare: data => http.Axios.post(rootPath + '/api/enterpriseWelfare/randomWelfare', data),

  // 获取购买人数
  GetPurchaseNum: data => http.Axios.post(rootPath + '/api/enterpriseWelfare/getPurchaseNum', data),

  // 详情
  WelfareDetail: data => http.Axios.post(rootPath + '/api/enterpriseWelfare/detail', data),

  // 分页查询
  GetWelfares: data => http.Axios.post(rootPath + '/api/enterpriseWelfare/getWelfares', data),
};
